export interface iUser{
    user_id:number;
    first_name:string;
    last_name:string;
    email:string;
    password?:string;
    created_at:string;
    updated_at:string;
}

export class User implements iUser{
    user_id: number = 0;
    first_name: string = "";
    last_name: string = "";
    email: string = "";
    created_at: string = "";
    updated_at: string = "";

    constructor(options?:iUser) {
        Object.assign(this, options);
    }
}